import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import UserReceivedLineIcon from 'remixicon-react/UserReceivedLineIcon';
import UserShared2LineIcon from 'remixicon-react/UserShared2LineIcon';

type NoQuestionsProps = {
  tab: string;
};

function NoQuestions({ tab }: NoQuestionsProps) {
  const theme = useTheme();

  return (
    <NoDataContainer>
      {tab === 'assigned-to-me' && (
        <>
          <UserReceivedLineIcon size={120} color={theme.palette.custom.steel} />
          <NoDataDescription>You have no assigned questions.</NoDataDescription>
        </>
      )}
      {tab === 'assigned-to-others' && (
        <>
          <UserShared2LineIcon size={120} color={theme.palette.custom.steel} />
          <NoDataDescription>No questions assigned to your team members.</NoDataDescription>
        </>
      )}
    </NoDataContainer>
  );
}

const NoDataContainer = styled(Box, { label: 'NoDataContainer' })({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  margin: '100px 24px 0',
});

const NoDataDescription = styled(Box, { label: 'NoDataDescription' })(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.custom.mistBlue,
}));

export default NoQuestions;
